import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import config from '../../../../config/config';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Fetch from '../functions/Fetch';
import { loadData } from '../Util/List/CustomList/loadData';

function List() {
  const sessionSelector = useSelector((state) => { return state.core.session });
  const friendly_url = sessionSelector.pdc_project_friendly_url;

  const filters = {
    validateOnChange: true,
    showGoBackButton: false,
    showSubmitButton: false,
    handleSubmit: loadData,
    fields: [
      {
        name: 'year',
        type: 'year',
        selectable: true,
        label: 'Ano',
        validations: {
          required: false
        },
        columnSize: 3
      },
      {
        name: 'filtro',
        type: 'submit',
        label: 'Pesquisar',
        columnSize: 1
      },
      {
        name: 'reset',
        type: 'reset',
        label: 'Limpar',
        columnSize: 2
      }
    ]
  };

  const paths = {
    endpoint: config.endpoints.backend + 'portal/getallcontracts'
  }

  let list = {
    labelTitle: 'Lista de Contratos',
    labelTitleButtonAdd: 'Incluir novo Contrato',
    fieldsShowOnDelete: ['contract_number'],
    canDownload: true,
    fieldToDownload: 'file',
    icon: 'fa-clipboard-check',
    formFilters: filters,
    filter: {
      friendly_url: friendly_url
    },
    columns: [
      {
        name: 'contract_number',
        label: 'Número do Contrato',
        width: '15%'
      },
      {
        name: 'process_number',
        label: 'Número do Processo',
        width: '15%'
      },
      {
        name: 'supplier_name',
        label: 'Fornecedor',
        width: '20%'
      },
      {
        name: 'object',
        label: 'Objeto'
      },
      {
        name: 'situation',
        label: 'Situação',
        width: '12%'
      },
      {
        name: 'effective_date',
        label: 'Data de Vigência',
        width: '12%'
      },
    ]
  };

  list = { ...list, ...paths };

  return (
    <div>
      <CustomListContainer
        canAdd={false}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={<CustomList list={{ ...list, ...paths }} />}
        icon={list.icon}
      />
    </div>
  );
}
export default List;
